import { render, staticRenderFns } from "./OnboardingSkills.vue?vue&type=template&id=b0909b7c&"
import script from "./OnboardingSkills.vue?vue&type=script&lang=js&"
export * from "./OnboardingSkills.vue?vue&type=script&lang=js&"
import style0 from "./OnboardingSkills.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports